import * as React from "react"

const SplideArrow = ({ previous, next }) => {
  const buttonStyles =
    "h-16 w-16 sm:h-20 sm:w-20 lg:h-24 lg:w-24 text-blue pointer flex items-center justify-center bg-navy hover:bg-blue hover:text-white transition duration-500 ease-in-out"

  return (
    <>
      {previous === true && (
        <button className={`splide__arrow splide__arrow--prev ${buttonStyles}`}>
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth={1}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className={"h-6 sm:h-8 lg:h-12"}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
            />
          </svg>
        </button>
      )}

      {next && (
        <button className={`splide__arrow splide__arrow--next ${buttonStyles}`}>
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth={1}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className={"h-6 sm:h-8 lg:h-12"}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </button>
      )}
    </>
  )
}

export default SplideArrow
